import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const LANGS = ["it", "en", "es"];

export const LanguageSwitcher = ({ dark = false }) => {
  const { t, i18n } = useTranslation();
  const cur = (i18n.language || "it").slice(0, 2);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors ${dark ? "text-white/80 hover:text-[#c6ff00]" : "text-black/70 hover:text-black"}`}
        >
          <Globe size={14} /> {t(`langs.${cur}`)}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px] rounded-xl border-black/10 p-1.5">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`lang-option-${l}`}
            onClick={() => i18n.changeLanguage(l)}
            className="flex cursor-pointer items-center justify-between rounded-lg px-3 py-2 text-sm font-semibold focus:bg-[#c6ff00]"
          >
            {t(`langs.${l}`)}
            {cur === l && <Check size={14} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
